import React from 'react';
import './divisons.css';

function Divisons() {
  return (
    <div className='mainCarousel'>
        This is the Divisons
    </div>
  );
}

export default Divisons;